import React, { useState } from 'react';

const Button7 = ({
    children,
    onClick,
    variant = 'primary',
    className = '',
    disabled = false,
    type = 'button',
}) => {
    const [hovered, setHovered] = useState(false);

    const baseStyle = {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        fontSize: '13px',
        fontWeight: 500,
        letterSpacing: '2px',
        textTransform: 'uppercase',
        padding: '14px 32px',
        borderRadius: '4px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.3s ease',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
    };

    const variants = {
        primary: {
            default: {
                backgroundColor: '#6366F1',
                color: '#FFFFFF',
                border: '1px solid #6366F1',
            },
            hover: {
                backgroundColor: '#4F46E5',
                color: '#FFFFFF',
                border: '1px solid #4F46E5',
            },
        },
        outline: {
            default: {
                backgroundColor: 'transparent',
                color: '#6366F1',
                border: '1px solid #6366F1',
            },
            hover: {
                backgroundColor: '#6366F1',
                color: '#FFFFFF',
                border: '1px solid #6366F1',
            },
        },
        silver: {
            default: {
                backgroundColor: '#E5E7EB',
                color: '#1E1B4B',
                border: '1px solid #E5E7EB',
            },
            hover: {
                backgroundColor: '#D1D5DB',
                color: '#1E1B4B',
                border: '1px solid #D1D5DB',
            },
        },
        ghost: {
            default: {
                backgroundColor: 'transparent',
                color: '#6366F1',
                border: '1px solid transparent',
            },
            hover: {
                backgroundColor: 'rgba(99, 102, 241, 0.08)',
                color: '#6366F1',
                border: '1px solid transparent',
            },
        },
    };

    const currentVariant = variants[variant] || variants.primary;
    const variantStyle = hovered && !disabled ? currentVariant.hover : currentVariant.default;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500&display=swap');
            `}</style>
            <button
                type={type}
                onClick={disabled ? undefined : onClick}
                disabled={disabled}
                className={className}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{ ...baseStyle, ...variantStyle }}
            >
                {children}
            </button>
        </>
    );
};

export default Button7;
